import React from 'react';
import { styled, createComponent } from '@workday/canvas-kit-react/common';
import { Box } from '@workday/canvas-kit-react/layout';
const StyledButtonLabel = styled(Box.as('span'))({
    position: 'relative',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
});
export const ButtonLabel = createComponent('span')({
    displayName: 'ButtonLabel',
    Component: ({ children, ...elemProps }, ref, Element) => {
        return (React.createElement(StyledButtonLabel, Object.assign({ as: Element, ref: ref }, elemProps), children));
    },
});
